import FeatureFlagRequestService from "./FeatureFlagRequestService";
import { storeDispatch } from "@/redux/store";
import { setError, setFeatureFlags } from "@/redux/featureFlagsSlice";
import { PartialFeatureFlags, FeatureFlagAvailability } from "@/central-atoms/feature-flags/types";

export default class FeatureFlagService {

    static async fetchAndApplyFeatureFlags(orgIds?: string[]): Promise<void> {
        try {
            
            const response = await FeatureFlagRequestService.fetchFeatureFlags({ org_id: orgIds?.join(',') || '' });
            const featureFlags = response.data;
            
                // Store the complete feature flag structure
                const flags: Record<string, FeatureFlagAvailability> = {};
                Object.keys(featureFlags).forEach(key => {
                    const flagData = featureFlags[key as keyof PartialFeatureFlags];
                    if (flagData) {
                        flags[key] = flagData;
                    }
                });
                
            storeDispatch(setFeatureFlags(flags));
        }
        catch (e: any) {
            console.error("Failed to fetch feature flags:", e);
            storeDispatch(setError("Failed to fetch feature flags:"));
            return Promise.reject(e);
        }
    }
}